import { render, staticRenderFns } from "./HistoryEventInfo.vue?vue&type=template&id=576ad5e5"
import script from "./HistoryEventInfo.vue?vue&type=script&lang=js"
export * from "./HistoryEventInfo.vue?vue&type=script&lang=js"
import style0 from "./HistoryEventInfo.vue?vue&type=style&index=0&id=576ad5e5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports